import { InsuredPeopleDto } from '@zorro/clients';

export const getWhoIsEnrolled = ({
  employee,
  spouse,
  dependents,
}: InsuredPeopleDto): string[] => {
  const whoIsEnrolled: string[] = [];
  whoIsEnrolled.push(employee.id);
  if (spouse) {
    whoIsEnrolled.push(spouse.id);
  }
  dependents.forEach((dependent) => whoIsEnrolled.push(dependent.id));

  return whoIsEnrolled;
};
